import React from 'react';
import { CollapseContent, CollapseHeader, CollapseWrapper } from './styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import cx from '../../../../utils/cx';

interface CollapseProps {
    title: React.ReactNode;
    isOpen?: boolean;
    onClick?: (isOpen: boolean) => void;
    defaultOpen?: boolean;
}

const Collapse = (props: React.PropsWithChildren<CollapseProps>) => {

    const [isOpen, setIsOpen] = React.useState(props.defaultOpen || false);

    const onClick = () => {
        setIsOpen(!isOpen);
        props.onClick?.(!isOpen);
    }

    React.useEffect(() => {
        if (props.isOpen !== undefined) {
            setIsOpen(!!props.isOpen);
        }
    }, [props.isOpen])

    return (
        <CollapseWrapper>
            <CollapseHeader onClick={onClick} className={cx({ active: isOpen })}>
                <FontAwesomeIcon icon={faAngleRight} />
                {props.title}
            </CollapseHeader>
            <CollapseContent className={cx({ active: isOpen })}>
                {props.children}
            </CollapseContent>
        </CollapseWrapper>
    )
}
export default Collapse;